import React from 'react'
import Annotation from './default-annotation'

const DefaultAnnotation = props => <Annotation {...props} mode="temporal" />

DefaultAnnotation.displayName = DefaultAnnotation.name

const annotationFeedRenderBuilder = () => ({
    priority: 100,
    component: DefaultAnnotation
})

export default annotationFeedRenderBuilder
